module.exports = __webpack_public_path__ + "img/BG@2x.854ed208.png";